<template>
    <div class="tab-grieve">
        <div class="tab-content">
            <div class="content-left">
                <ul class="operation-list">
                    <li class="operation-item" @click="selectOperationItem(index,item)" :class="{active:currentOperationIndex==index}" v-for="(item,index) in operationList" :key="index">
                        <i class="icon" :class="item.key"></i>
                        {{item.name}}
                    </li>
                </ul>
            </div>
            <div class="content-right">
                <ul class="grieve-list" v-if="grieveList !== undefined && grieveList.length">
                    <li class="grieve-item" v-for="(item,index) in grieveList" :key="index" >
                        <div class="img-left"><img class="img" :src="item.image" alt=""></div>
                        <div class="info-right">
                            <div class="base-info">
                                <div class="graver line-group">
                                    <span class="label">祭扫人：</span>
                                    <span >{{item.title}}</span>
                                </div>
                                <div class="relation line-group">
                                    <span class="label">关系：</span>
                                    <span >{{item.relation}}</span>
                                </div>
                                <div class="createTime line-group">
                                    <span >{{item.createTime}}</span>
                                </div>
                            </div>
                            <div class="message">{{item.content}}</div>
                        </div>
                    </li>
                </ul>
                <div class="no-data" v-else>暂时还没数据</div>
            </div>
        </div>
        <Page :total="pageTotal" v-if="totalPages >= 1" :page-size="grievePageInfo.pageSize" show-total @on-change="pageChange" />
    </div>
</template>

<script>
    var self
    import api from '../../../api/api'
    import {mapState} from 'vuex'
    export default {
        name: 'grieve',
        props:['memorialId'],
        // watch:{
        //     memorialId: {
        //         // immediate:true,
        //         handler(val) {
        //             this.memorialId = val;
        //             this.getGrieveList()
        //         }
        //     }
        // },
        mounted(){
            self = this;
            console.log('mounted--------',this.memorialId)
            this.getGrieveList()
        },
        activated(){
            // console.log('activated--------',this.memorialId)
            // this.getGrieveList()
        },
        data(){
            return{
                currentOperationIndex:0,
                currentType:'flower',
                operationList:[{
                    key:'flower',
                    name:'献花',
                },{
                    key:'music',
                    name:'点歌',
                },{
                    key:'wine',
                    name:'祭酒',
                }],
                grieveList:[],
                grievePageInfo:{
                    page:0,
                    pageSize:6
                },
                pageTotal:0,
                totalPages:0
            }
        },
        methods:{
            pageChange(index){
                // console.log('index:',index)
                this.grievePageInfo.page = index-1
                this.getGrieveList()
            },
            getGrieveList(isRest){
                if(isRest){ //重置到献花
                    this.currentType = 'flower';
                    this.currentOperationIndex = 0
                }
                // console.log('currentMemorialId--->>',this.memorialId)
                if(!this.memorialId)return
                this.grieveList = [];
                var data = {
                    memorialId:this.memorialId,
                    jisaoType:this.currentType
                }
                Object.assign(data,this.grievePageInfo)
                api.getGrieveList(data).then(res=>{
                    self.grieveList = res.rows
                    self.grievePageInfo.page=res.page
                    self.pageTotal = res.total
                    self.totalPages = res.totalPages
                })
            },
            selectOperationItem(index,item){
                if(index==this.currentOperationIndex)return
                this.grievePageInfo.page=0
                this.currentOperationIndex = index;
                this.currentType = item.key;
                this.getGrieveList()
            },
        }
    }
</script>

<style scoped lang="scss">
    .tab-grieve{
        padding: 60px 50px 60px 250px;
        .tab-content{
            min-height: 500px;
            padding-bottom: 20px;
            .content-left{
                float: left;
                margin-left: -201px;
                height: 100%;
                .operation-list{
                    height: 100%;
                    border-right: 1px solid #E8E8E8;
                    .operation-item{
                        width: 200px;
                        height: 44px;
                        font-size: 16px;
                        color: #333;
                        line-height: 44px;
                        border-right: 2px solid transparent;
                        .icon{
                            width: 25px;
                            height: 25px;
                            text-align: center;
                            display: inline-block;
                            background-size: inherit;
                            vertical-align: text-bottom;
                            &.flower{
                                background-image: url('../../../assets/images/icon/flower_dark.jpg');
                            }
                            &.music{
                                background-image: url('../../../assets/images/icon/music_dark.jpg') ;
                            }
                            &.wine{
                                background-image: url('../../../assets/images/icon/wine_dark.jpg') ;
                            }
                        }
                        &:hover{
                            cursor: pointer;
                        }
                        &.active{
                            border-right-color:#009DE9;
                            background: #E8F3FD;
                        }
                    }
                }
            }
            .content-right{
                float: left;
                width: 100%;
                padding-left: 40px;
                margin-bottom: 50px;
                color: #333;
                font-size: 16px;
                .grieve-list{
                    .grieve-item{
                        padding:20px 10px 20px 115px;
                        border-bottom: 1px dashed #DCDCDC;
                        overflow: hidden;
                        .img-left{
                            float: left;
                            width: 115px;
                            height: 115px;
                            margin-left: -115px;
                            .img{
                                width: 100%;
                            }
                        }
                        .info-right{
                            float: left;
                            padding-left: 20px;
                            width: 100%;
                            .base-info{
                                overflow: hidden;
                                padding-bottom: 20px;
                                .line-group{
                                    float: left;
                                    width: 33%;
                                    text-align: left;
                                    &.createTime{
                                        color: #949494;
                                        text-align: right;
                                    }
                                }
                            }
                            .message{
                                text-align: left;
                            }
                        }
                    }
                }
                .no-data{
                    padding: 20px;
                    font-size: 20px;
                }
            }
        }

    }
</style>
